/* this file added by Bearer Web Developer  */
import React from 'react';
import styles from './destination.module.scss';
import { TReservedOrderDetails } from '../../../../states/reservedOrdersState/models/reservedOrderDetails';
import Name from './name';
import { useThemeMode } from '../../../../states/contexts/theme';
interface Props {
    order: TReservedOrderDetails
}
const Destination: React.FC<Props> = ({ order }) => {
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.destination} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <div className={styles.address}>
                <img src="/destination.png" alt="destination" width={26} height={26} />
                <p>{order?.destination_address}</p>
            </div>
            <Name recipient_name={order?.recipient_name} />
        </div>
    )
}
export default Destination;